/**
 *  Detecting variable types helpers. Can be imported in any component.
 */

export const isArray = function (arr) {
    /**
     * Checks if given param is an array
     * @param  {[any]} arr
     * @return {[boolean]}
     */
    return Array.isArray(arr);
};

export const isObject = function (obj) {
    /**
     * Checks if given param is an object
     * @param  {[any]} obj
     * @return {[boolean]}
     */
    return obj === Object(obj) && !isArray(obj) && typeof obj !== "function";
};

export const hasValidProperty = (obj: any, key: string) => {
    /**
     * Checks if a given object has a given key and if the
     * property of the key is not null
     * @param {[any]} any
     * @param {[string]} key
     * @returns {[boolean]}
     */
    if ([undefined, "undefined", null, "null"].includes(obj)) {
        return false;
    } else {
        return obj.hasOwnProperty(key) && obj[key] !== null;
    }
};

export const isValidBase64 = (str: string): boolean => {
    /**
     * Checks whether a given string is a valid Base64-encoded string.
     * This function attempts to decode the string with `atob` and then
     * re-encode it with `btoa`. If the process succeeds and the re-encoded
     * string matches the original, the input is considered valid Base64.
     * @param {string} str - The string to validate as Base64.
     * @returns {boolean}
     */
    try {
        // decode then re-encode, see if it matches
        return btoa(atob(str)) === str;
    } catch {
        return false;
    }
};
